<template>
  <div >
    <!--  <button class="" @click="change(type, id)">-->
    <!--    <img   :src="src"/>-->
    <!--  </button>-->
    <!--  <div class="card-toolbar">-->
    <!--    <div class="dropdown dropdown-inline text-left float-left">-->
    <!--&lt;!&ndash;      <a @click="change(type, id)" class="btn btn-clean  btn-sm btn-icon" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">&ndash;&gt;-->
    <!--&lt;!&ndash;        <i class="ki ki-bold-more-ver"></i>&ndash;&gt;-->
    <!--&lt;!&ndash;      </a>&ndash;&gt;-->
    <!--    </div>-->

    <!--  </div>-->

    <div class="col-xxl-6 left-align text-left float-left">
      <div  class="dropdown  dropright" data-placement="right" style=" margin-left: -50px;">
        <button v-if="false" class="btn hover-opacity-40 btn-sm btn-icon " data-toggle="dropdown"
                aria-haspopup="true" aria-expanded="false">
          <i class="ki ki-bold-more-ver"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-md dropdown-menu-right " style="margin-top: 58px; margin-right: -218px">
          <!--begin::Naviigation-->
            <div class="p-3">
            <span v-for="(pro, index) in item.property" :key="index"><br>
                              <i class="fa fa-check-circle "></i> {{ pro.text }}
                 </span>
            </div>
          <!--end::Naviigation-->

        </div>
      </div>
    </div>


  </div>
</template>

<script>
export default {
  name: "BtnUPAndDown",
  props: ['id', 'item'],
  data() {
    return {
      type: 'down',
      src: 'media/svg/icons/Navigation/Angle-double-down.svg'
    }
  },
  methods: {
    change(type, id) {
      const card = document.querySelector(`div[data-id='${id}']`);
      const att = document.querySelector(`div[data-attribute='${id}']`);

      if (type === 'down') {
        this.type = 'up';
        this.src = 'media/svg/icons/Navigation/Angle-double-up.svg';
        $(att).show(750)
      }
      if (type === 'up') {
        this.type = 'down'
        $(att).hide(750)
        this.src = 'media/svg/icons/Navigation/Angle-double-down.svg'
      }

    },
  }

}
</script>

<style scoped>

.fa-check-circle {
  color: #04d504;
}


</style>